export default __webpack_public_path__ + "static/media/CWBI_Logo_45x45.e31f8db6.png";